import React from 'react';
import './FormInput.css';

function FormInput({ label, type = 'text', value, onChange, placeholder, error, required, disabled, ...props }) {
  return (
    <div className="form-input-group">
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        type={type}
        className={`form-input ${error ? 'error' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormInput;


